import { render, staticRenderFns } from "./organization-asset-group-category-asset-group-inventory-list-view.vue?vue&type=template&id=b10323dc&scoped=true"
import script from "./organization-asset-group-category-asset-group-inventory-list-view.vue?vue&type=script&lang=js"
export * from "./organization-asset-group-category-asset-group-inventory-list-view.vue?vue&type=script&lang=js"
import style0 from "./organization-asset-group-category-asset-group-inventory-list-view.vue?vue&type=style&index=0&id=b10323dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10323dc",
  null
  
)

export default component.exports